import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { QueueTypeEnum } from 'src/app/samwebDescription/samwin/QueueTypeEnum';
import { UserActionSettingChanged } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.actions';
import { ToolbarSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.state';
import { SamwinOutboundSkillShortInfoState } from 'src/app/store/samwin/samwin-outbound-skill-shortinfo/samwin-outbound-skill-shortinfo.state';
import { MakeCallActionSettingRemoteDto } from 'src/generated/signalR/make-call-action-setting-remote-dto';
import { QueueShortInfoRemoteDto } from 'src/generated/swagger';
import { ActionSpecificSettingsComponent } from '../action-specific-settings-component';

@Component({
   selector: 'samweb-make-call-action-settings',
   templateUrl: './make-call-action-settings.component.html',
   styleUrls: ['./make-call-action-settings.component.scss'],
})
export class MakeCallActionSettingsComponent extends ActionSpecificSettingsComponent implements OnInit {
   public actionSetting$: Observable<MakeCallActionSettingRemoteDto>;

   public isLoadingSelectableSkills$: Subject<boolean>;

   public selectableSkills$: Observable<QueueShortInfoRemoteDto[]>;

   public selectedSkill$: Observable<QueueShortInfoRemoteDto>;

   constructor(private store: Store, private translateService: TranslateService) {
      super();
   }

   ngOnInit(): void {
      this.actionSetting$ = this.store.select(ToolbarSettingsState.getActionSettingFn).pipe(
         map((fn) => fn(this.brickInstanceId, this.toolbarId, this.actionId)),
         map((x) => x as MakeCallActionSettingRemoteDto),
         map((x) => _.cloneDeep(x))
      );

      this.isLoadingSelectableSkills$ = new Subject<boolean>();
      this.isLoadingSelectableSkills$.next(true);

      this.selectableSkills$ = this.store.select(SamwinOutboundSkillShortInfoState.getSkills).pipe(
         map((skills) => {
            this.isLoadingSelectableSkills$.next(false);
            if (skills.length > 0) {
               return skills;
            }

            // if no outbound skills are configured, provide the default skill
            const defaultSkill: QueueShortInfoRemoteDto = {
               id: 0,
               name: this.translateService.instant('user_actions.types.make_call.settings.default_skill'),
               queueTypeId: QueueTypeEnum.SKILL.value,
            };
            return [defaultSkill];
         })
      );

      this.selectedSkill$ = combineLatest([this.actionSetting$, this.selectableSkills$]).pipe(
         switchMap(([settings, skills]) => {
            const selectedValue = _.find(skills, (skill) => {
               if (skill.id === settings.skillId) {
                  return skill;
               }
            }) as QueueShortInfoRemoteDto;

            if (_.isNil(selectedValue)) {
               return of(_.first(skills));
            }
            return of(selectedValue);
         })
      );
   }

   skillChanged(settings: MakeCallActionSettingRemoteDto, value: QueueShortInfoRemoteDto) {
      settings.skillId = value.id;
      this.store.dispatch(new UserActionSettingChanged(this.brickInstanceId, this.toolbarId, this.actionId, settings));
   }
}
